export default __webpack_public_path__ + "static/media/Update2.88f345c6.png";